"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BREAK_POINTS = exports.mapSizeClasses = exports.mapSize = exports.calculateSpan = exports.hasSpan = exports.resolveSpan = exports.getNodeSpan = exports.validSpan = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _constants = require("../utils/constants");

var validSpan = function validSpan(span) {
  return typeof span === 'number' && 0 < span && span < 13;
};

exports.validSpan = validSpan;

var getNodeSpan = function getNodeSpan(node, size) {
  var _node$props;

  var nodeSpan = node === null || node === void 0 ? void 0 : (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.span;
  if (validSpan(nodeSpan)) return nodeSpan;
  if (nodeSpan && validSpan(nodeSpan[size])) return nodeSpan[size];
  return 0;
};

exports.getNodeSpan = getNodeSpan;

var resolveSpan = function resolveSpan(propValue, size, fallback) {
  if (validSpan(propValue)) return propValue;
  if (propValue && validSpan(propValue[size])) return propValue[size];
  return fallback;
};

exports.resolveSpan = resolveSpan;

var hasSpan = function hasSpan(node, size) {
  var _node$props2;

  var nodeSpan = node === null || node === void 0 ? void 0 : (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.span;
  return validSpan(nodeSpan) || nodeSpan && validSpan(nodeSpan[size]);
};

exports.hasSpan = hasSpan;

var calculateSpan = function calculateSpan(child, avail, siblings, size) {
  var _child$props, _child$props3, _child$props3$span;

  var calculatedSpan = 12;

  if (validSpan(child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.span)) {
    var _child$props2;

    calculatedSpan = child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.span;
  } else if (validSpan(child === null || child === void 0 ? void 0 : (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : (_child$props3$span = _child$props3.span) === null || _child$props3$span === void 0 ? void 0 : _child$props3$span[size])) {
    var _child$props4, _child$props4$span;

    calculatedSpan = child === null || child === void 0 ? void 0 : (_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : (_child$props4$span = _child$props4.span) === null || _child$props4$span === void 0 ? void 0 : _child$props4$span[size];
  } else {
    calculatedSpan = Math.round(avail[size] / siblings[size]);
    avail[size] = avail[size] - calculatedSpan;
    siblings[size] = siblings[size] - 1;
  }

  return 0 < calculatedSpan && calculatedSpan < 13 ? calculatedSpan : 12;
};

exports.calculateSpan = calculateSpan;

var mapSize = function mapSize(action) {
  var _context;

  var newObj = {};
  (0, _forEach.default)(_context = (0, _keys.default)(_constants.SCREEN_SIZE_MAP)).call(_context, function (size) {
    newObj[size] = action(size);
  });
  return newObj;
};

exports.mapSize = mapSize;

var mapSizeClasses = function mapSizeClasses(action, namespace) {
  var _context2;

  var newObj = {};
  (0, _forEach.default)(_context2 = (0, _keys.default)(_constants.SCREEN_SIZE_MAP)).call(_context2, function (size) {
    var _context3, _context4;

    newObj[(0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(namespace, "-")).call(_context4, _constants.SCREEN_SIZE_MAP[size])).call(_context3, action(size))] = action(size);
  });
  return newObj;
};

exports.mapSizeClasses = mapSizeClasses;
var BREAK_POINTS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12];
exports.BREAK_POINTS = BREAK_POINTS;